import type { ReactNode } from 'react';

export type AlertTone = 'info' | 'success' | 'attention' | 'critical';

export interface AlertProps {
  readonly tone?: AlertTone;
  readonly title?: string;
  readonly children: ReactNode;
}

/**
 * Status messaging.
 *
 * Tone is carried by an explicit label as well as colour, and anything urgent is announced
 * assertively — priority is never conveyed by colour alone.
 */
export function Alert({ tone = 'info', title, children }: AlertProps): ReactNode {
  const urgent = tone === 'critical' || tone === 'attention';

  return (
    <div
      className={`alert alert--${tone}`}
      role={urgent ? 'alert' : 'status'}
      aria-live={urgent ? 'assertive' : 'polite'}
    >
      {title === undefined ? null : <strong className="alert__title">{title}</strong>}
      <div className="alert__body">{children}</div>
    </div>
  );
}
